import Vue from 'vue';
import VueRouter from 'vue-router';
import PromoHome from '../views/PromoHome';
import Health from '../views/Health';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Promo',
    component: PromoHome,
  },
  {
    path: '/health',
    name: 'Health',
    component: Health,
  },
  {
    path: '/detail',
    name: 'Detail Promo',
    component: () =>
      import(/* webpackChunkName: "promo-detail" */ '../views/PromoDetail'),
  },
  {
    path: '/location',
    name: 'Lokasi Promo',
    component: () =>
      import(/* webpackChunkName: "promo-location" */ '../views/PromoLocation'),
  },
  {
    path: '/merchants',
    name: 'Daftar Merchant',
    component: () =>
      import(/* webpackChunkName: "merchant-list" */ '../views/MerchantList'),
  },
];


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default router;
